var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoogleLogin = function SvgGoogleLogin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9.655 16.83-.652 2.437-2.386.05A9.333 9.333 0 0 1 5.5 14.876c0-1.555.378-3.02 1.048-4.311l2.124.389.93 2.11a5.573 5.573 0 0 0-.3 1.812c0 .688.125 1.348.353 1.956Z",
    fill: "#FBBB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.086 13.124a9.393 9.393 0 0 1-.041 3.709 9.373 9.373 0 0 1-3.3 5.353h-.001l-2.675-.137-.379-2.363a5.587 5.587 0 0 0 2.404-2.854h-5.013v-3.708h9.006Z",
    fill: "#518EF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.744 22.185v.001a9.335 9.335 0 0 1-5.869 2.064 9.374 9.374 0 0 1-8.258-4.932l3.038-2.487a5.574 5.574 0 0 0 8.035 2.855l3.054 2.5Z",
    fill: "#28B446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.859 7.658-3.037 2.487a5.576 5.576 0 0 0-8.22 2.92L6.55 10.563A9.373 9.373 0 0 1 14.874 5.5c2.275 0 4.36.81 5.984 2.158Z",
    fill: "#F14336"
  }))));
};
export default SvgGoogleLogin;